import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import VizHeader from "../VizHeader/VizHeader";
import { Collapse } from "antd";
import QuestionsFilter from "./QuestionsFilter";
import TimeframeFilters from "./TimeframeFilters";
import UsersFilter from "./UsersFilter";
import AdditionalFilter from "./AdditionalFilter";
import { SettingFilled } from "@ant-design/icons";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./ExpertRecordsStyles.module.css";

export default function ExpertRecordsFilters({ flag, onClose }) {
  const dispatch = useDispatch();
  const expertRecordsState = useSelector((state) => state.expertRecord);
  const {
    cmrQuestionsFilter,
    cmrTimeFrameFilter,
    cmrAskFilter,
    cmrUsersFilter,
  } = bindActionCreators(Actions, dispatch);
  const [questionsFilterState, setQuestionsFilterState] = useState({
    rating: expertRecordsState.rating,
    cc: expertRecordsState.cc,
    cs: expertRecordsState.cs,
    status: expertRecordsState.status,
    spill: expertRecordsState.spill,
  });
  const onChangeQuestionsFilter = (val, key) => {
    if (key === "status") {
      setQuestionsFilterState({
        ...questionsFilterState,
        rating: [],
        status: val,
        spill: false,
      });
    }
    if (key === "rating") {
      setQuestionsFilterState({
        ...questionsFilterState,
        status: [],
        rating: val,
        spill: false,
      });
    }
    if (key === "cs") {
      setQuestionsFilterState({ ...questionsFilterState, cs: val });
    }
    if (key === "cc") {
      setQuestionsFilterState({ ...questionsFilterState, cc: val });
    }
    if (key === "spill") {
      setQuestionsFilterState({
        ...questionsFilterState,
        status: [],
        rating: [],
        spill: val,
      });
    }
  };
  const [askDateState, setAskDateState] = useState({
    from: "",
    to: "",
  });
  const onChangeAskFilter = (val, key) => {
    if (key === "from") {
      setAskDateState({ ...askDateState, from: val });
    }
    if (key === "to") {
      setAskDateState({ ...askDateState, to: val });
    }
  };
  const [usersState, setUsersState] = useState({
    seekers: [],
    experts: [],
    seekerType: "",
  });
  const onChangeUsersFilter = (val, key) => {
    if (key === "seekers") {
      setUsersState({ ...usersState, seekers: usersState.seekers.concat(val) });
    }
    if (key === "experts") {
      setUsersState({ ...usersState, experts: usersState.experts.concat(val) });
    }
    if (key === "seekerType") {
      setUsersState((prev) => ({
        ...prev,
        seekerType: val,
      }));
    }
  };
  const [timeFrameState, setTimeFrameState] = useState({
    excludeEmail: expertRecordsState.excludeEmail,
    express: expertRecordsState.urgent,
    isLastUpdate: expertRecordsState.nonCurated,
    fromDate: expertRecordsState.curatedFromDate,
    toDate: expertRecordsState.curatedToDate,
    lastUpdateBy: expertRecordsState.curatedBy,
  });
  const onChangeTimeFrameFilter = (val, key) => {
    if (key === "email") {
      setTimeFrameState({ ...timeFrameState, excludeEmail: val });
    }
    if (key === "express") {
      setTimeFrameState({ ...timeFrameState, express: val });
    }
    if (key === "isLast") {
      setTimeFrameState({
        ...timeFrameState,
        isLastUpdate: val,
        fromDate: "",
        toDate: "",
        lastUpdateBy: [],
      });
    }
    if (key === "lastBy") {
      setTimeFrameState({ ...timeFrameState, lastUpdateBy: val });
    }
    if (key === "from") {
      setTimeFrameState({ ...timeFrameState, fromDate: val });
    }
    if (key === "to") {
      setTimeFrameState({ ...timeFrameState, toDate: val });
    }
  };
  const labelFunc = (text) => {
    return (
      <>
        <span style={{ width: "100%" }}>{text}</span>
      </>
    );
  };
  const onClickRemoveUserFilter = (val, key) => {
    if (key === "seeker") {
      let filteredData = usersState.seekers.filter((obj) => {
        if (obj.email !== val.email) {
          return obj;
        }
      });
      setUsersState({ ...usersState, seekers: filteredData });
    }
    if (key === "expert") {
      let filteredData = usersState.experts.filter((obj) => {
        if (obj.email !== val.email) {
          return obj;
        }
      });
      setUsersState({ ...usersState, experts: filteredData });
    }
  };
  let items = [
    {
      key: "1",
      label: labelFunc("Question"),
      children: (
        <QuestionsFilter
          state={questionsFilterState}
          onChangeFunc={onChangeQuestionsFilter}
        />
      ),
    },
    {
      key: "2",
      label: labelFunc("Timeframe"),
      // Swapping Timeframe children with Additional Details children as per requirement.
      children: (
        <AdditionalFilter
          state={askDateState}
          onChangeFunc={onChangeAskFilter}
        />
      ),
    },
    {
      key: "3",
      label: labelFunc("Users"),
      children: (
        <UsersFilter
          state={usersState}
          onChangeFunc={onChangeUsersFilter}
          onRemoveFunc={onClickRemoveUserFilter}
        />
      ),
    },
    {
      key: "4",
      label: labelFunc("Additional Details"),
      // Swapping Timeframe children with Additional Details children as per requirement
      children: (
        <TimeframeFilters
          state={timeFrameState}
          onChangeFunc={onChangeTimeFrameFilter}
        />
      ),
    },
  ];
  const onClickSubmit = () => {
    cmrTimeFrameFilter(timeFrameState);
    cmrQuestionsFilter(questionsFilterState);
    cmrAskFilter(askDateState);
    cmrUsersFilter(usersState);
    onClose();
  };

  useEffect(() => {
    setUsersState({
      seekers: expertRecordsState.seekers,
      experts: expertRecordsState.experts,
      seekerType: expertRecordsState.seekerType || "",
    });
    setAskDateState({
      from: expertRecordsState.fromDate,
      to: expertRecordsState.tillDate,
    });
    setTimeFrameState({
      excludeEmail: expertRecordsState.excludeEmail,
      express: expertRecordsState.urgent,
      isLastUpdate: expertRecordsState.nonCurated,
      fromDate: expertRecordsState.curatedFromDate,
      toDate: expertRecordsState.curatedToDate,
      lastUpdateBy: expertRecordsState.curatedBy,
    });
    setQuestionsFilterState({
      rating: expertRecordsState.rating,
      status: expertRecordsState.status,
      cc: expertRecordsState.cc,
      cs: expertRecordsState.cs,
      spill: expertRecordsState.spill,
    });
  }, [flag]);
  return (
    <>
      <div style={{ textAlign: "center" }}>
        <VizHeader type={4}>
          <SettingFilled style={{ fontSize: "20px", fontWeight: "300" }} />
          &nbsp;&nbsp;Expert Records Filters
        </VizHeader>
        <Divider style={{ marginTop: "5px" }} />
        <div style={{ width: "100%" }}>
          <Collapse accordion expandIconPosition={"end"} items={items} />
        </div>
        <div className="mt-2">
          <button
            className={Styles.submitFilterButton}
            style={{
              padding: "8px 12px 8px 12px",
              borderRadius: "6px",
              fontSize: "14px",
              lineHeight: "24px",
              fontWeight: 400,
              boxShadow: "0px 1px 2px 0px #1018280D",
              color: "#FFFFFF",
              border: "1px solid  #fff",
              height: "40px",
              minWidth: "88px",
              background:
                "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
              marginBottom: "14px",
              // cursor:selectedExpert.length  ? "not-allowed" : "pointer",
            }}
            onClick={() => onClickSubmit()}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
}
